import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { withRouter, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { getPolicie } from "../../../store/policies/actions";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Title",
      conent: "Content",
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getPolicie(id);
    
  }

  render() {
    const { title, icon, content,  loading } = this.props; // Corrigido para this.props

    return (
      <div style={{ padding: "30px", background: "#Fff" }}>
        {loading ? 
          <div><Spinner animation="border" variant="secondary" /></div>
         : 
          <div>
          <h1>{title}</h1>

          <div dangerouslySetInnerHTML={{ __html: content }} />
        
        </div>
        }
      </div>
    );
  }
}

Index.PropTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,

  id: PropTypes.any,
  getPolicie: PropTypes.any,
  data: PropTypes.any,
  title: PropTypes.any,
  icon: PropTypes.any,
  content: PropTypes.any,
  show_menu: PropTypes.any,
};

const mapStateToProps = (state, props) => {
  const { data, loading, title, icon, content, show_menu } = state.Policie;

  return {
    data,
    loading,
    title,
    icon,
    content,
    show_menu,
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, { getPolicie })(Index))
);
